import React, { useState } from "react";
import { useLocation,useNavigate } from "react-router";
import { Stepper,Step } from "@progress/kendo-react-layout";
import { REWARDS_CAMPAIGNS_ADD } from "../../../routes";

const items = [
    {
      label: "Campaign Info",
      value: 0,
    },    
    {
      label: "Upload Nominees List",
      value: 1,
    },        
    {
      label: "Review",
      value: 2,
    }
  ];

  const itemsWithoutId = [
    {
      label: "Campaign Info",
      value: 0,
    },        
    {
      label: "Review",
      value: 2,
    }
  ];

  const CustomStep = (props) => {
      return (
        <Step {...props}>
          <div className="custom-step">
            <span>{props.svgIcon}</span>
          </div>
          <span className="step-label">{props.label}</span>
        </Step>
      );
    };
export const AddCampaignSteps = (props) => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search); 
  const id = query.get("id"); 
  const handleChange = (e) => {
    // e.preventDefault();
    if(e.value != 0){
      if (props.checkMandatoryFields()) return;
    }
    if(query.get("id")){
      if(props.isSplashOnly && e.value != 0){
        props.setState(e.value+1);
        query.set("state",e.value+1);
      }
      else{
        let tab = e.value > 0 && !isShowNominationTab() ? 2 : e.value
        props.setState(tab);
        query.set("state",tab);  
      }
      navigate(REWARDS_CAMPAIGNS_ADD+"?"+query.toString());     
    }else {
      props.handleSubmit(false);
    }
  };


  const isShowNominationTab = () => {

    let isShow = false;

    if((props.editData.status == "Pending Nomination" || props.editData.status == "Approved") && !props.isAdmin && props.isValidator){
      isShow = true;
    }

    // if(props.editData.status == "Rejected" && props.isAdmin){
    //   isShow = true;
    // }
  

    return isShow;
  };
  
  return (
    <>
        <div className="poll-progress-steps-group">
            <div className="progress-steps-inside-group">
                <Stepper 
                  className="campaigns_steps" 
                  value={id && isShowNominationTab() ? props.state : itemsWithoutId.findIndex(x => x.value === props.state)} 
                  items={id && isShowNominationTab() ? items : itemsWithoutId}
                  // item={CustomStep}
                  onChange={(e)=>handleChange(e)} 
                />
            </div>
        </div>
    </>
  );
};